/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Typography,
} from '@material-ui/core';
import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { Loader } from '../../../components/icons/Loader';
import InfiniteScroll from 'react-infinite-scroll-component';
import { t } from 'i18next';
import { colors } from '../../../helpers/colors';

const styles = {
  box: {
    width: '100%',
    height: '275px',
    overflowY: 'auto',
    overflowX: 'hidden',
  },

  text: {
    fontSize: '12px',

    color: '#464545',
  },
  subtitle: {
    fontStyle: 'italic',
    fontSize: '0.75em',
    color: colors.grey,
  },
};

const EmployeeList = (props) => {
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const handleSelect = (e, employee) => {
    const checked = e.target.checked;
    let current = [...selectedEmployees];
    if (checked) {
      current.push(employee.id);
    } else {
      const remaining = _.filter(current, function (d) {
        return d != employee.id;
      });
      current = remaining;
    }

    setSelectedEmployees(current);
    props.onSelect(current);
  };

  useEffect(() => {
    setSelectedEmployees([]);
    props.onSelect([]);
  }, []);

  useEffect(() => {
    if (props.action === 'Unselect All') {
      const ids = _.map(props?.ids, 'id');
      setSelectedEmployees(ids);
      props.onSelect(ids);
    } else {
      setSelectedEmployees([]);
      props.onSelect([]);
    }
  }, [props.action]);


  return (
    <InfiniteScroll
      style={styles.box}
        dataLength={props.employees.length}
        next={props.fetching}
        height={props?.height ? props?.height : '445px'}
        hasMore={props?.hasmore}
        loader={
          <Loader height={50} />
        }
        endMessage={<p className='text-center text-gray-200'>{t('No more items to load')}</p>}
    >
      <FormControl className="w-full" component="fieldset" variant="standard">
        <FormGroup
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          className="w-full"
        >
          {_.map(props.employees, (data, index) => {
            return (
              <FormControlLabel
                value={data.id}
                key={data.id}
                className="w-full !mr-0"
                control={
                  <Checkbox
                    size="small"
                    checked={selectedEmployees.includes(Number(data.id))}
                    onChange={(e) => handleSelect(e, data)}
                    style={{
                      color: '#7C0E6F',
                      '&.MuiChecked': {
                        color: '#7C0E6F',
                      },
                    }}
                  />
                }
                label={
                <Box>
                    <Typography
                    style={styles.text}
                  >{`${data.first_name} ${data.last_name} `}</Typography>
                  <Typography style={styles.subtitle}>{"id:" + data.staff_id}</Typography>
                </Box>
                }
              />
            );
          })}
          {props.isFetching && (
            <Loader height = {100}/>
          )}
        </FormGroup>
      </FormControl>
    </InfiniteScroll>
  );
};

export default EmployeeList;
